export default {
  zIndex: {
    navbar: 1000,
    dropdown: 1000,
    popover: 1060,
    tooltip: 1070,
    navbarFixed: 1030,
    modalBackground: 1040,
    modal: 1050
  },
  gridBreakpoints: {
    xs: 0,
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
  containerMaxWidths: {
    sm: '540px',
    md: '720px',
    lg: '960px',
    xl: '1140px'
  }
};